import { render } from "./StyleWrap.vue?vue&type=template&id=35ee9cc2"
import script from "./StyleWrap.vue?vue&type=script&lang=js"
export * from "./StyleWrap.vue?vue&type=script&lang=js"

import "./StyleWrap.vue?vue&type=style&index=0&id=35ee9cc2&lang=scss"

import exportComponent from "/home/runner/work/PEP/PEP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__